export default __webpack_public_path__ + "media/images/front/snsBnr/sp_sns_close-6dfb54937310750929c5f5e0022e75eb.png";